<template>
  <div class="main">
    <div class="daohang">
      <el-menu active-text-color="#ffd04b" background-color="#545c64" class="el-menu-vertical-demo" text-color="#fff"
        @open="handleOpen" @close="handleClose" :default-openeds="['1', '2']">
        <el-sub-menu index="1">
          <template #title>
            <el-icon>
              <location />
            </el-icon>
            <span>系统信息管理</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="1-1" @click="handleMenuClick('FileTreeView')">资源树查询</el-menu-item>
            <el-menu-item index="1-2" @click="handleMenuClick('FilesView')">文件管理</el-menu-item>
            <el-menu-item v-if="adminuser.level == 1" index="1-3"
              @click="handleMenuClick('CatalogInfoView')">目录管理</el-menu-item>
            <el-menu-item index="1-4" @click="handleMenuClick('SourseInfoView')">资源管理</el-menu-item>
              <el-menu-item index="1-5" @click="handleMenuClick('AddSourceView')">资源新增</el-menu-item>
          </el-menu-item-group>
        </el-sub-menu>

        <el-sub-menu index="2">
          <template #title>
            <el-icon>
              <location />
            </el-icon>
            <span>设置</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="3-1" @click="goToolsHome">工具箱</el-menu-item>
            <el-menu-item index="3-1" @click="out">退出登录</el-menu-item>
          </el-menu-item-group>
        </el-sub-menu>
      </el-menu>
    </div>
    <div class="xuanxiangka">
      <div style="width: 100%">
        <DynamicContent :component="currentComponent" />
      </div>
    </div>
  </div>
</template>

<script>
import WelcomeView from "./Welcome.vue";
import DynamicContent from "./DynamicContent.vue";
import FilesView from "./file/FilesView.vue"
import FileTreeView from "./source/ResourceTree.vue"
import SourseInfoView from "./source/SourseInfo.vue";
import CatalogInfoView from "./catalog/CatalogInfo.vue";
import AddSourceView from "./source/AddSourse.vue";

export default {
  components: {
    DynamicContent,
    FilesView,
    FileTreeView,
    SourseInfoView,
    AddSourceView
  },
  name: "AdminHomeView",
  data() {
    return {
      role: sessionStorage.getItem("role"),
      zh: sessionStorage.getItem("usercode"),
      currentComponent: WelcomeView,
      // 组件映射
      componentsMap: {
        FilesView,
        FileTreeView,
        SourseInfoView,
        CatalogInfoView,
        AddSourceView
      },
      adminuser: JSON.parse(sessionStorage.getItem("adminuser")),
    };
  },
  mounted() {
  },
  methods: {
    out() {
      sessionStorage.removeItem("usercode");
      sessionStorage.removeItem("role");
      sessionStorage.setItem("s", false);
      this.$router.replace("/login");
    },
    goToolsHome() {
      this.$router.replace("/");
    },
    handleClick(row) {
      console.log(row);
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },

    handleMenuClick(component) {
      this.currentComponent = this.componentsMap[component];
    },
  },
};
</script>

<style scoped>
.main {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
}

.daohang {
  width: 20%;
}

.xuanxiangka {
  width: 80%;
}
</style>
